module.exports = {
    "isAnimation": true,
    "frames": [
        {
            "time": 16,
            "image": require("./1.png").default
        },
        {
            "time": 32,
            "image": require("./2.png").default
        },
        {
            "time": 48,
            "image": require("./3.png").default
        },
        {
            "time": 64,
            "image": require("./4.png").default
        },
        {
            "time": 80,
            "image": require("./5.png").default
        },
        {
            "time": 96,
            "image": require("./6.png").default
        },
        {
            "time": 112,
            "image": require("./7.png").default
        },
        {
            "time": 128,
            "image": require("./8.png").default
        },
        {
            "time": 128 + (16 * 4),
            "image": require("./9.png").default
        },
        {
            "time": 128 + (16 * 5),
            "image": require("./8.png").default
        },
        {
            "time": 128 + (16 * 6),
            "image": require("./7.png").default
        },
        {
            "time": 128 + (16 * 7),
            "image": require("./6.png").default
        },
        {
            "time": 128 + (16 * 8),
            "image": require("./5.png").default
        },
        {
            "time": 128 + (16 * 9),
            "image": require("./4.png").default
        },
        {
            "time": 128 + (16 * 10),
            "image": require("./3.png").default
        },
        {
            "time": 128 + (16 * 11),
            "image": require("./2.png").default
        },
        {
            "time": 128 + (16 * 12),
            "image": require("./1.png").default
        },
        {
            "time": 128 + (16 * 13),
        },
    ]
}
